module.exports = __webpack_public_path__ + "img/headphone.e3f2c527.svg";